/**
 * AN APPOINTMENT INTO THE CUSTOMER'S OWN CALENDAR — a .ics file the phone or the desktop opens in its calendar.
 * Moved out of Pages/BookedSuccessfull (10-23) so the business page chat's appointment cards add to the calendar the
 * same way the booking confirmation does.
 */

/** Format ISO date for ICS (UTC): YYYYMMDDTHHmmssZ */
export function toICSDate(isoStr) {
  if (!isoStr) return "";
  const d = new Date(isoStr);
  const pad = (n) => String(n).padStart(2, "0");
  const y = d.getUTCFullYear();
  const m = pad(d.getUTCMonth() + 1);
  const day = pad(d.getUTCDate());
  const h = pad(d.getUTCHours());
  const min = pad(d.getUTCMinutes());
  const s = pad(d.getUTCSeconds());
  return `${y}${m}${day}T${h}${min}${s}Z`;
}

/** Build and trigger download of an ICS file for the appointment */
export function addToCalendar({ title, description, location, url, startsAt, endsAt }) {
  const start = toICSDate(startsAt);
  const end = toICSDate(endsAt);
  if (!start || !end) return;
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "BEGIN:VEVENT",
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${(title || "Appointment").replace(/\n/g, " ")}`,
    description ? `DESCRIPTION:${description.replace(/\n/g, " ").replace(/,/g, "\\,")}` : "",
    location ? `LOCATION:${location.replace(/\n/g, " ").replace(/,/g, "\\,")}` : "",
    url ? `URL:${url}` : "",
    "END:VEVENT",
    "END:VCALENDAR",
  ]
    .filter(Boolean)
    .join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "appointment.ics";
  link.click();
  URL.revokeObjectURL(link.href);
}
